<template>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelText
        labelXl="6"
        labelLg="9"
        labelMd="10"
        labelSm="8"
        textXl="6"
        textLg="3"
        textMd="2"
        textSm="4"
        id="txt_span_details_unit_key"
        label="SU.01 Unit Key"
        v-model="structureUnit.strUnitKey"
      >
      </LabelText>
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelText
        labelXl="6"
        labelLg="9"
        labelMd="10"
        labelSm="8"
        textXl="6"
        textLg="3"
        textMd="2"
        textSm="4"
        id="txt_span_details_strUnitLabel"
        label="SU.02 Unit ID"
        v-model="structureUnit.strUnitLabel"
      >
      </LabelText>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="12" md="12" lg="12">
      <LabelText
        labelXl="12"
        labelLg="12"
        labelMd="12"
        labelSm="12"
        textXl="12"
        textLg="12"
        textMd="12"
        textSm="12"
        id="txt_span_details_structureunitdescription"
        label="SU.03 Structure Unit Description"
        v-model="structureUnit.strUnitDescription"
        type="textarea"
        maxlength="255"
        counter
        persistentCounter
      >
      </LabelText>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        textXl="6"
        textLg="6"
        textMd="6"
        textSm="6"
        id="txt_span_details_legacy_structure_type"
        label="SU.04 Legacy Structure Type"
        v-model="structureUnit.legacyStructureType"
        :refTable="REFERENCE_TABLE.STRUCTURE_TYPE"
      >
      </LabelSelect>
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelText
        labelXl="6"
        labelLg="9"
        labelMd="10"
        labelSm="8"
        textXl="6"
        textLg="3"
        textMd="2"
        textSm="4"
        id="txt_span_details_span_length"
        label="SP.21 Span Length"
        v-model="structureUnit.spanLength"
        appendWith=" ft"
        type="number"
        :decimalPlaces="1"
        :roundingFactor="ROUNDING_FACTOR.TENTH"
      >
      </LabelText>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        textXl="6"
        textLg="6"
        textMd="6"
        textSm="6"
        id="txt_span_details_legacy_main_span_set_indicator"
        label="SP.02 Main Span Set Indicator"
        v-model="structureUnit.mainSpanSetIndicator"
        :refTable="REFERENCE_TABLE.MAIN_SPANSET_INDICATOR"
      >
      </LabelSelect>
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelCheckbox
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        class="labelCheckbox"
        id="checkbox_span_details_span_flared"
        label="SP.22 Span Flared"
        v-model="structureUnit.spanFlared"
      ></LabelCheckbox>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelText
        labelXl="6"
        labelLg="9"
        labelMd="10"
        labelSm="8"
        textXl="6"
        textLg="3"
        textMd="2"
        textSm="4"
        id="txt_span_details_span_config_designation"
        label="B.SP.01 Span Config. Designation"
        v-model="structureUnit.spanConfigDesignation"
      >
      </LabelText>
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        textXl="6"
        textLg="6"
        textMd="6"
        textSm="6"
        :refTable="REFERENCE_TABLE.FC_GROUP_NUMBER"
        id="txt_span_details_nstm_group"
        label="SP.03 NSTM Group"
        v-model="structureUnit.nstmGroupNumber"
      >
      </LabelSelect>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelText
        labelXl="6"
        labelLg="9"
        labelMd="10"
        labelSm="8"
        textXl="6"
        textLg="3"
        textMd="2"
        textSm="4"
        id="txt_span_details_span_number_of_beam_lines"
        label="B.SP.03 Number of Beam Lines"
        v-model="structureUnit.numberOfBeamLines"
      >
      </LabelText>
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <v-row>
        <v-col sm="6"> <v-label class="bold">SP.05 Type of Steel: </v-label></v-col>
        <v-col class="pl-4">{{ steelTypeDisplayValue(structureUnit.structureUnitSteelTypes?.map(s=>s.steelType)) }}</v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`superstructure_span_details_span_material`"
        label="B.SP.04 Span Material"
        :refTable="REFERENCE_TABLE.SPAN_MATERIAL"
        v-model="structureUnit.spanMaterial"
      />
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`superstructure_span_details_span_material`"
        label="SP.24 Dept Material Type"
        :refTable="REFERENCE_TABLE.MATERIAL_MAKEUP"
        v-model="structureUnit.deptMaterialType"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`superstructure_span_details_span_continuity`"
        label="B.SP.05 Span Continuity"
        :refTable="REFERENCE_TABLE.SPAN_CONTINUITY"
        v-model="structureUnit.spanContinuity"
      />
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`superstructure_span_details_dept_physical_type`"
        label="SP.25 Dept Physical Type"
        :refTable="REFERENCE_TABLE.PHYSICAL_MAKEUP"
        v-model="structureUnit.deptPhysicalType"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`superstructure_span_details_span_type`"
        label="B.SP.06 Span Type"
        :options="getSpanTypes"
        v-model="structureUnit.spanType"
      />
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="'select_superstructure_span_details_span_Interact'"
        label="SP.26 Dept Span Inter"
        :refTable="REFERENCE_TABLE.SPAN_INTERACTION"
        v-model="structureUnit.deptSpanInteraction"
      ></LabelSelect>
    </v-col>
  </v-row>
  <v-row>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`span_prot_system`"
        label="B.SP.07 Span Prot. System"
        :refTable="REFERENCE_TABLE.SPAN_PROTECTION_SYSTEM"
        v-model="structureUnit.spanProtectSystem"
      />
    </v-col>
    <v-col sm="6" md="6" lg="6">
      <LabelSelect
        labelXl="6"
        labelLg="6"
        labelMd="6"
        labelSm="6"
        selectXl="6"
        selectLg="6"
        selectMd="6"
        selectSm="6"
        :id="`select_Struct_Config`"
        label="SP.27 Dept Struc Config"
        :refTable="REFERENCE_TABLE.STRUCTURAL_CONFIGURATION"
        v-model="structureUnit.deptStrucConfig"
      ></LabelSelect>
    </v-col>
  </v-row>
</template>
<script setup>
import { computed, toRefs } from "vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useConfigStore } from "@/stores/config";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import { steelTypeDisplayValue } from "@/composables/spanBySpan";

const props = defineProps({
  structureUnit: Object,
});
const { structureUnit } = toRefs(props);

const configStore = useConfigStore();

const getSpanTypes = computed(() => {
  const allSpanTypes = configStore.getReferenceValues(REFERENCE_TABLE.SPAN_TYPE);
  //if structure type is Sign or Light
  if (["S", "H"].includes(props.structureType)) {
    return allSpanTypes.filter((s) =>
      ["HM01", "SS01", "SS02", "SS03", "SS04", "SS05", "SS06", "SS07", "SS08", "SS09", "SS10", "SS11"].includes(
        s.value,
      ),
    );
  } else if (["N", "R"].includes(props.structureType)) {
    //walls
    return allSpanTypes.filter((s) =>
      [
        "NW01",
        "NW02",
        "NW03",
        "NW04",
        "RW01",
        "RW02",
        "RW03",
        "RW04",
        "RW05",
        "RW06",
        "RW07",
        "RW08",
        "RW09",
        "RW10",
        "RW11",
        "RW12",
        "RW13",
      ].includes(s.value),
    );
  } else if (["T"].includes(props.structureType)) {
    return allSpanTypes.filter((s) => ["TUN"].includes(s.value));
  } else {
    return allSpanTypes;
  }
});
</script>
